import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store'; // Adjust to your store's path

const useAuthorization = () => {
    const user = useSelector((state: RootState) => state.user.user);

    const hasLevel = (level: string): boolean => {
        return !!user?.levels?.includes(level);
    };

    const hasRole = (role: string): boolean => {
        return !!user?.roles?.includes(role);
    };

    const hasAccess = (level: string, role: string): boolean => {
        return hasLevel(level) && hasRole(role);
    };

    return { hasLevel, hasRole, hasAccess };
};

export default useAuthorization;
